import FolderZipOutlinedIcon from '@mui/icons-material/FolderZipOutlined';
import { Button, CircularProgress } from '@mui/material';
import { useState } from 'react';
import { useNotify, useRecordContext } from 'react-admin';
import { downloadArtBundle } from '../lib/download';
import { AppArt, AppArtFile } from '../types';

interface Props {
  /** Os arquivos que o botão cobre. A galeria passa a lista viva; o cabeçalho, o record. */
  files: AppArtFile[];
  label?: string;
}

/**
 * Baixa o material num zip só.
 *
 * O bucket do pacote é DERIVADO dos arquivos recebidos, em vez de vir por
 * prop: assim não existe como a lista mostrada na tela e o conteúdo do zip
 * discordarem. Uma galeria só tem arquivos de um bucket, e o cabeçalho passa o
 * record inteiro — que atravessa buckets e leva o material completo.
 */
const DownloadAllButton = ({ files, label = 'Baixar todos (.zip)' }: Props) => {
  const record = useRecordContext<AppArt>();
  const notify = useNotify();
  const [busy, setBusy] = useState(false);

  // Zip vazio é só frustração: sem arquivo, o botão não aparece.
  if (!record || !files.length) { return null; }

  const [first] = files;
  const bucket = files.every(file => file.bucket === first.bucket) ? first.bucket : undefined;

  const run = async () => {
    setBusy(true);
    try {
      const { missing } = await downloadArtBundle(record.chainId, {
        bucket, chainName: record.chainName,
      });
      if (missing) {
        notify(`${missing} arquivo(s) não estavam mais no storage e ficaram de fora do zip.`,
          { type: 'warning' });
      }
    } catch (error: any) {
      notify(error?.message || 'Não foi possível montar o zip', { type: 'error' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      size="small"
      variant="outlined"
      onClick={run}
      disabled={busy}
      startIcon={busy ? <CircularProgress size={14} /> : <FolderZipOutlinedIcon />}
    >
      {busy ? 'Montando o zip…' : `${label} (${files.length})`}
    </Button>
  );
};

export default DownloadAllButton;
